import React from "react";
import styled from "styled-components";
import img1 from "../images/side.svg";
import img2 from "../images/engineer.svg";
import img3 from "../images/s.svg";
import img4 from "../images/travel.svg";
import rectangleImage from "../images/hero-arrow.png";

const servicesData = [
  {
    title: "SEO Optimization",
    detail:
      "Improve your website's search engine ranking with our SEO expertise.",
    image: img1,
  },
  {
    title: "Web & Mobile Development",
    detail:
      "Develop your Website/Web Application or Mobile Application by professionals",
    image: img2,
  },

  {
    title: "Digital Marketing",
    detail:
      "Boost your online presence with our comprehensive digital marketing services.",
    image: img3,
  },

  {
    title: "E-commerce Solutions",
    detail: "Setup and optimize e-commerce platforms for online sales.",
    image: img4,
  },
];

const Services = () => {
  return (
    <Container>
      <RectangleImage src={rectangleImage} alt="Rectangle" />
      <Title>Let us solve your critical website development challenges</Title>
      <Description>
        At our digital marketing agency, we offer a full suite of services to
        elevate your online presence and drive business growth. From SEO to
        email campaigns, we use data-driven strategies to deliver measurable
        results and ensure your success in the digital realm. Partner with us to
        transform your marketing efforts and stay ahead of the competition.
      </Description>
      <ServiceContainer>
        {servicesData.map((service, index) => (
          <ServiceCard key={index}>
            <ServiceImage>
              <img src={service.image} alt={service.title} />
            </ServiceImage>
            <ServiceTitle>{service.title}</ServiceTitle>
            <ServiceDetail>{service.detail}</ServiceDetail>
          </ServiceCard>
        ))}
      </ServiceContainer>
      <ButtonContainer>
        <StyledButton>Free SEO Consultation</StyledButton>
        <StyledButton secondary>Get A Free Quote</StyledButton>
      </ButtonContainer>
    </Container>
  );
};

const Container = styled.div`
  padding: 40px 20px;
  background: #f0f4f8;
`;

const RectangleImage = styled.img`
  width: 100%;
  max-width: 800px;
  height: 250px;
  display: block;
  margin: 0 auto 20px auto;
  padding-top: 6rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  text-align: center;
  color: #333;
  margin-bottom: 20px;
`;

const Description = styled.p`
  font-size: 1.2rem;
  text-align: center;
  margin: 1rem 0 2rem 0;
  color: #555;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const ServiceContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  padding: 20px;
`;

const ServiceCard = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin: 15px;
  padding: 20px;
  transition: transform 0.3s;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:hover {
    transform: translateY(-10px);
  }
`;

const ServiceImage = styled.div`
  margin-top: 15px;
  margin-bottom: 20px;

  img {
    max-width: 100%;
    height: 200px;
  }
`;

const ServiceTitle = styled.h3`
  font-size: 1.5rem;
  margin: 10px 0;
  color: #333;
`;

const ServiceDetail = styled.p`
  font-size: 1rem;
  color: #777;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 2rem;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
`;

const StyledButton = styled.button`
  background: ${(props) => (props.secondary ? "#f9f9f9" : "#4CAF50")};
  color: ${(props) => (props.secondary ? "#333" : "#fff")};
  border: 1px solid ${(props) => (props.secondary ? "#ddd" : "#4CAF50")};
  padding: 12px 20px;
  font-size: 1rem;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: ${(props) => (props.secondary ? "#f0f0f0" : "#45a049")};
    border: 1px solid ${(props) => (props.secondary ? "#ccc" : "#45a049")};
  }

  @media (max-width: 768px) {
    width: 80%;
    text-align: center;
  }
`;

export default Services;
